import { useTranslation } from 'react-i18next';
import CrudPage from '../../../../Template/layoutComponents/CrudPage';

import {
  getDepartments,
  newDepartment,
  updateDepartment,
} from '../../../../Maintenance/helpers/apiCalls';

import useMaintenanceState from '../../../../Maintenance/atoms/variables';

import './style.css';

const Departments = () => {
  const { t } = useTranslation();

  const { orgs } = useMaintenanceState();

  return (
    <div id='departmentPage'>
      <CrudPage
        title={t('departments')}
        newText={t('new_department')}
        detailsLink={'/settings/departments'}
        defaultItem={{
          new: true,
          label: t('new_department'),
          properties: [
            {
              label: t('name'),
              type: 'text',
              value: t('new_department'),
              main: true,
              required: true,
              disabled: false,
              key: 'name',
            },
            {
              label: t('organization_id'),
              type: 'singleSelect',
              value: null,
              options: orgs,
              main: true,
              required: true,
              disabled: false,
              key: 'organization_id',
            },
            {
              label: t('out_of_service'),
              type: 'bool',
              value: false,
              required: true,
              allowEdit: true,
              disabled: false,
              key: 'out_of_service',
            },
          ],
        }}
        getAllItems={getDepartments}
        newItem={newDepartment}
        updateItem={updateDepartment}
      />
    </div>
  );
};

export default Departments;
